import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


import { defineComponent } from 'vue';

const __default__ = defineComponent({
  name: 'Margin',
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  block: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props

_useCssVars(_ctx => ({
  "28997bf4": (_unref(margin)),
  "24e53089": (_unref(marginMedium)),
  "5052b0b2": (_unref(marginLarge))
}))



const margin = computed(() => props.block.margin);
const marginMedium = computed(() => props.block.marginMedium || props.block.margin);
const marginLarge = computed(() => props.block.marginLarge || props.block.marginMedium || props.block.margin);
const style = computed(() => props.block.backgroundColor ? `background-color: ${props.block.backgroundColor}` : '');

return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock("div", {
    class: "margin-block",
    style: _normalizeStyle(_unref(style))
  }, [
    _createVNode(_component_blocks_repeater, {
      blocks: props.block.blocks
    }, null, 8, ["blocks"])
  ], 4))
}
}

})